
import { defineComponent } from "vue";
import IconButton from "../inputs/IconButton.vue";
import Color from "../inputs/Color.vue";
import Delete from "../icons/Delete.vue";

export default defineComponent({
  components: {
    IconButton, Delete, Color,
  },
  props: {
    modelValue: { type: String, required: true },
  },
  emits: [
    "update:modelValue",
    "remove",
  ],
});
